import { Link } from "react-router-dom";
import { H5, LI, P, UL } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constants/Constants";
import { InformationCommonPropsType } from "../../../../../Types/SearchResultType";
import { Rating } from "react-simple-star-rating";

const InformationCommon: React.FC<InformationCommonPropsType> = ({ item }) => {
  return (
    <div className="info-block">
      <Link to={Href}>{item.url}</Link>
      <H5>{item.title}</H5>
      <P>{item.detail}</P>
      <div className="star-ratings">
        <UL className="search-info simple-list flex-row">
          {item.showStar ? <LI className="rating"><Rating initialValue={3} size={17} className="mt-1" /></LI> : ""}
          <LI>{item.star}</LI>
          <LI>{item.vote}</LI>
          <LI>{item.news}</LI>
        </UL>
      </div>
    </div>
  );
};

export default InformationCommon;
